exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3g8vfTCSpWKmUcxSWO3yOF{height:3.57143rem;width:3.57143rem}.fePwUNv7cNBZD_-62VWLK{color:#a4a4a4}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"UserCard_picture": "_3g8vfTCSpWKmUcxSWO3yOF",
	"UserCard_date": "fePwUNv7cNBZD_-62VWLK"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./components/UserCard/style.postcss
// module id = 1349
// module chunks = 0